const DEFAULT_SIZE_PX = 20;

// A rising trade line with a play mark: "run this trade and see where it goes". Colour follows the text.
export const SimulateTradeIcon = ({ size = DEFAULT_SIZE_PX }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M3 14.5 8 9.5l4 3L20 4.5" />
    <path d="M15 4.5h5v5" />
    <path d="M14.5 14.8v6.4a.6.6 0 0 0 .9.5l5.2-3.2a.6.6 0 0 0 0-1l-5.2-3.2a.6.6 0 0 0-.9.5Z" fill="currentColor" />
  </svg>
);
